import { AnchorsOfForms, AnchorsOfFormsWrappers } from '@constants/forms'
import { apiUrls } from '@http/api-urls'
import { httpService } from '@http/service'
import { transformPartnerFormToDto } from '@shared/components/forms/partner/transform.dto'
import { SimplePersonForm } from '@shared/components/forms/shared/simple-person-form'
import { changeDocumentHash } from '@shared/pipes/dom'
import scrollToElement from '@shared/pipes/scroll'

interface Props {
	btnText?: string
	placeholders?: string[]
}

const defaultBtnText = 'Стать партнёром'

export const PartnerForm = ({
	btnText = defaultBtnText,
	placeholders = ['Фамилия, имя, отчество', 'Номер телефона', 'Электронная почта'],
}: Props) =>
	SimplePersonForm({
		placeholders,
		formId: AnchorsOfForms.partner,
		onSubmit: (form) => httpService.post(apiUrls.sendBrokerInfo(), transformPartnerFormToDto(form)),
		buttonText: (isSubmitted) =>
			isSubmitted ? 'Спасибо за заявку. В течение 30 минут с\u00A0вами свяжется менеджер' : btnText,
	})

export const scrollToPartnerForm = () => {
	scrollToElement(`#${AnchorsOfFormsWrappers.partner}`, { time: 100 }, () => {
		changeDocumentHash(AnchorsOfFormsWrappers.partner)
	})
}
